module.exports = __webpack_public_path__ + "static/img/enterpriseCertificationSuccess.a75a682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterpriseCertificationSuccess.png
// module id = ow8f
// module chunks = 1